// extracted by mini-css-extract-plugin
export default {"navbar":"NavBar_navbar__9mAZG","appList":"NavBar_appList__FxWca","userPanel":"NavBar_userPanel__Vs5+O"};